package com.hyperether.goodjob.scenes.contacts

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.ButtonDefaults
import androidx.compose.material.Divider
import androidx.compose.material.OutlinedButton
import androidx.compose.material.Text
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Close
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.style.TextAlign
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.Sp
import com.hyperether.goodjob.log
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.back_arrow
import com.hyperether.goodjob.resources.cancel
import com.hyperether.goodjob.resources.city
import com.hyperether.goodjob.resources.clear_all
import com.hyperether.goodjob.resources.confirm
import com.hyperether.goodjob.resources.contact_type
import com.hyperether.goodjob.resources.filter
import com.hyperether.goodjob.resources.filter_empty
import com.hyperether.goodjob.resources.industry
import com.hyperether.goodjob.scenes.components.FilterSectionMobile
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.toggleSelection
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.scenes.register.FilledButton
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun FilterContactsDialog(
    cities: List<String>,
    industries: List<String>,
    contactTypes: List<String>,
    onDismiss: () -> Unit,
    isMobileView: Boolean,
    viewModel: ContactsViewModel,
    onApply: (cities: Set<String>, industries: Set<String>, contactTypes: Set<String>) -> Unit
) {

    log.d("FilterContactsDialog") { "Recomposing cities:${cities.size} industries:${industries.size} types:${contactTypes.size}" }
    if (isMobileView) {
        Box(modifier = Modifier.fillMaxSize()) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.5f))
                    .clickable(
                        onClick = {},
                        indication = null,
                        interactionSource = remember { MutableInteractionSource() })
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .align(Alignment.Center)
                        .background(Color.White)
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(Dp(16f)),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        androidx.compose.material.Icon(
                            painter = painterResource(Res.drawable.back_arrow),
                            contentDescription = "Back icon",
                            modifier = Modifier
                                .weight(1f)
                                .offset(x = -Dp(30f))
                                .align(Alignment.CenterVertically)
                                .clickable {
                                    onDismiss()
                                }
                        )
                        DisableSelection {
                            Text(
                                text = stringResource(Res.string.filter),
                                textAlign = TextAlign.Center,
                                color = Color.Black,
                                fontSize = Sp(20f),
                                modifier = Modifier
                                    .weight(3f)
                                    .align(Alignment.CenterVertically)
                            )
                        }
                        DisableSelection {
                            Text(
                                text = stringResource(Res.string.clear_all),
                                textAlign = TextAlign.End,
                                fontSize = Sp(14f),
                                color = BlueApp,
                                modifier = Modifier
                                    .weight(1f)
                                    .align(Alignment.CenterVertically)
                                    .clickable {
                                        viewModel.selectedCities.value = emptySet()
                                        viewModel.selectedIndustries.value = emptySet()
                                        viewModel.selectedContactTypes.value = emptySet()
                                    }
                            )
                        }
                    }
                    Divider(
                        modifier = Modifier.height(Dp(2f))
                            .background(Color.LightGray.copy(alpha = 0.1f))
                    )

                    Column(
                        modifier = Modifier
                            .padding(start = Dp(16f))
                            .weight(1f)
                            .verticalScroll(rememberScrollState())
                            .disableMouseDragScrollOnWeb()
                    ) {
                        if (cities.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(Dp(15f)))

                            FilterSectionMobile(
                                title = stringResource(Res.string.city),
                                options = cities,
                                selectedOptions = viewModel.selectedCities.value,
                                onOptionSelected = { city ->
                                    viewModel.selectedCities.value =
                                        toggleSelection(viewModel.selectedCities.value, city)
                                }
                            )
                        }

                        if (industries.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(Dp(10f)))

                            FilterSectionMobile(
                                title = stringResource(Res.string.industry),
                                options = industries,
                                selectedOptions = viewModel.selectedIndustries.value,
                                onOptionSelected = { industry ->
                                    viewModel.selectedIndustries.value = toggleSelection(
                                        viewModel.selectedIndustries.value,
                                        industry
                                    )
                                }
                            )
                        }

                        if (contactTypes.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(Dp(10f)))

                            FilterSectionMobile(
                                title = stringResource(Res.string.contact_type),
                                options = contactTypes,
                                selectedOptions = viewModel.selectedContactTypes.value,
                                onOptionSelected = { type ->
                                    viewModel.selectedContactTypes.value =
                                        toggleSelection(viewModel.selectedContactTypes.value, type)
                                }
                            )
                        }

                        val citiesEmpty = cities.isEmpty() || cities.all { it.isBlank() }
                        val industriesEmpty =
                            industries.isEmpty() || industries.all { it.isBlank() }
                        val typesEmpty =
                            contactTypes.isEmpty() || contactTypes.all { it.isBlank() }
                        if (citiesEmpty && industriesEmpty && typesEmpty) {
                            Spacer(modifier = Modifier.height(Dp(20f)))
                            Text(
                                text = stringResource(Res.string.filter_empty),
                                textAlign = TextAlign.Center,
                                fontSize = Sp(14f),
                                color = Color.Gray,
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .align(Alignment.CenterHorizontally)
                            )
                        }
                    }
                    FilledButton(
                        onClick = {
                            onApply(
                                viewModel.selectedCities.value,
                                viewModel.selectedIndustries.value,
                                viewModel.selectedContactTypes.value
                            )
                            onDismiss()
                        },
                        modifier = Modifier.padding(
                            start = Dp(16f),
                            end = Dp(16f),
                            top = Dp(30f),
                            bottom = Dp(20f)
                        ),
                        text = stringResource(Res.string.confirm),
                        isEnabled = true,
                    )
                }
            }
        }
    } else {
        Box(
            modifier = Modifier
                .fillMaxHeight()
                .clickable(
                    onClick = {},
                    indication = null,
                    interactionSource = remember { MutableInteractionSource() }
                )
        ) {
            Column(
                modifier = Modifier
                    .width(370.toScaleDp())
                    .align(Alignment.Center)
                    .shadow(8.toScaleDp(), RoundedCornerShape(12.toScaleDp()))
                    .clip(RoundedCornerShape(12.toScaleDp()))
                    .background(Color.White)
                    .padding(16.toScaleDp())
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxHeight()
                        .background(Color.White)
                ) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(8.toScaleDp()),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        DisableSelection {
                            Text(
                                text = stringResource(Res.string.filter),
                                textAlign = TextAlign.Center,
                                color = Color.Black,
                                fontSize = 20.toScaleSp(),
                                modifier = Modifier.align(Alignment.CenterVertically)
                            )
                        }
                        DisableSelection {
                            Text(
                                text = stringResource(Res.string.clear_all),
                                textAlign = TextAlign.End,
                                fontSize = 14.toScaleSp(),
                                color = BlueApp,
                                modifier = Modifier
                                    .align(Alignment.CenterVertically)
                                    .padding(start = 15.toScaleDp())
                                    .clickableWithPointer {
                                        viewModel.selectedCities.value = emptySet()
                                        viewModel.selectedIndustries.value = emptySet()
                                        viewModel.selectedContactTypes.value = emptySet()
                                    }
                            )
                        }
                        Spacer(modifier = Modifier.weight(1f))

                        androidx.compose.material.Icon(
                            imageVector = Icons.Default.Close,
                            contentDescription = "Back icon",
                            modifier = Modifier
                                .align(Alignment.CenterVertically)
                                .clickableWithPointer {
                                    onDismiss()
                                }
                        )
                    }
                    val scrollState = rememberScrollState()
                    Column(
                        horizontalAlignment = Alignment.CenterHorizontally,
                        modifier = Modifier
                            .weight(1f)
                            .verticalScrollbar(scrollState)
                            .verticalScroll(scrollState)
                            .disableMouseDragScrollOnWeb()
                            .padding(start = 8.toScaleDp(), end = 8.toScaleDp())
                    ) {
                        if (cities.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(15.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.city),
                                options = cities,
                                selectedOptions = viewModel.selectedCities.value,
                                onOptionSelected = { city ->
                                    viewModel.selectedCities.value =
                                        toggleSelection(viewModel.selectedCities.value, city)
                                }
                            )
                        }

                        if (industries.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(10.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.industry),
                                options = industries,
                                selectedOptions = viewModel.selectedIndustries.value,
                                onOptionSelected = { industry ->
                                    viewModel.selectedIndustries.value = toggleSelection(
                                        viewModel.selectedIndustries.value,
                                        industry
                                    )
                                }
                            )
                        }

                        if (contactTypes.any { it.isNotBlank() }) {
                            Spacer(modifier = Modifier.height(10.toScaleDp()))

                            FilterSectionMobile(
                                title = stringResource(Res.string.contact_type),
                                options = contactTypes,
                                selectedOptions = viewModel.selectedContactTypes.value,
                                onOptionSelected = { type ->
                                    viewModel.selectedContactTypes.value =
                                        toggleSelection(
                                            viewModel.selectedContactTypes.value,
                                            type
                                        )
                                }
                            )
                        }

                        val citiesEmpty = cities.isEmpty() || cities.all { it.isBlank() }
                        val industriesEmpty =
                            industries.isEmpty() || industries.all { it.isBlank() }
                        val typesEmpty =
                            contactTypes.isEmpty() || contactTypes.all { it.isBlank() }
                        if (citiesEmpty && industriesEmpty && typesEmpty) {
                            Spacer(modifier = Modifier.height(Dp(20f)))
                            Text(
                                text = stringResource(Res.string.filter_empty),
                                textAlign = TextAlign.Center,
                                fontSize = Sp(14f),
                                color = Color.Gray,
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .align(Alignment.CenterHorizontally)
                            )
                        }
                    }
//                    Spacer(modifier = Modifier.weight(1f))
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(top = 16.toScaleDp()),
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        OutlinedButton(
                            onClick = { onDismiss() },
                            modifier = Modifier
                                .weight(1f)
                                .height(50.toScaleDp())
                                .pointerHoverIcon(PointerIcon.Hand),
                            border = BorderStroke(1.toScaleDp(), BlueApp),
                            shape = RoundedCornerShape(50),
                            colors = ButtonDefaults.outlinedButtonColors(
                                contentColor = Color.White,
                                backgroundColor = Color.Transparent
                            )
                        ) {
                            DisableSelection {
                                Text(
                                    text = stringResource(Res.string.cancel),
                                    maxLines = 1,
                                    fontSize = 12.5f.toScaleSp(),
                                    color = BlueApp,
                                )
                            }
                        }
                        Spacer(modifier = Modifier.width(10.toScaleDp()))
                        FilledButton(
                            onClick = {
                                onApply(
                                    viewModel.selectedCities.value,
                                    viewModel.selectedIndustries.value,
                                    viewModel.selectedContactTypes.value
                                )
                                onDismiss()
                            },
                            text = stringResource(Res.string.confirm),
                            isEnabled = true,
                            modifier = Modifier.weight(1f)
                        )
                    }
                }
            }
        }
    }
}
